module.exports = __webpack_public_path__ + "img/assistant.90789cfb.webp";